import isAuthenticatedAdmin from './isAuthenticatedAdmin';
import hasPermissions from './hasPermissions';
import isTelemetryEnabled from './isTelemetryEnabled';

export default { isAuthenticatedAdmin, hasPermissions, isTelemetryEnabled };
